import script from "./StandardizedLocationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./StandardizedLocationModal.vue?vue&type=script&setup=true&lang=js"

import "./StandardizedLocationModal.vue?vue&type=style&index=0&id=6fd9b934&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fd9b934"]])

export default __exports__